interface thmeProps {
  [key: string]: any;
}
const theme: thmeProps = {
  palette: {
    blue_900: '#286DF0',
    blue_deep: '#0045C7',
    blue_opacity_100: 'rgba(40, 109, 240, 0.1)',
    blue_opacity_400: 'rgba(40, 109, 240, 0.38)',
    blue_opacity_500: '#3D51FF',

    red_900: '#ED1313',
    red_deep: '#AA0029',
    red_opacity_100: 'rgba(237, 19, 19, 0.1)',
    red_opacity_400: 'rgba(237, 19, 19, 0.38)',

    yellow_900: '#FFBF00',
    yellow_deep: '#CA9100',
    yellow_opacity_100: 'rgba(255, 191, 0, 0.1)',
    yellow_opacity_400: 'rgba(255, 191, 0, 0.38)',

    green_900: '#0DD621',
    green_deep: '#038F11',
    green_opacity_100: 'rgba(13, 214, 33, 0.1)',
    green_opacity_400: 'rgba(13, 214, 33, 0.38)',

    gray_neautral_scrollbar: '#C4C4C4',
    transparent: 'rgba(0, 0, 0, 0)',
  },
  fontStyle: {
    h1: `font-size: 48px;`,
    h2: `font-size: 42px;`,
    h3: `font-size: 36px;`,
    h4: `font-size: 26px;`,
    h5: `font-size: 24px;`,
    h6: `font-size: 20px;`,
    title: `font-size: 18px;`,
    body1: `font-size: 16px;`,
    body2: `font-size: 15px;`,
    subtitle: `font-size: 14px;`,
    caption: `font-size: 13px;`,
  },
  commonPadding: `padding: 16px 20px;`,
  commonMargin: `margin: 16px 20px;`,
  commonSpace: `padding: 16px 20px;`,
  commonTopBottomPadding: `padding-top: 16px; padding-bottom: 16px;`,
};

// neautral gray
[
  '#F9F9F9',
  '#F5F5F5',
  '#EFEFEF',
  '#E5E5E5',
  '#DBDBDB',
  '#BDBDBD',
  '#909090',
  '#606060',
  '#303030',
  '#121212',
].forEach((item, index) => {
  theme.palette[`gray_neautral_${index === 0 ? '50' : index * 100}`] = item;
});

// opacity gray
[
  '#FFFFFF',
  'rgba(0, 0, 0, 0.06)',
  'rgba(0, 0, 0, 0.1)',
  'rgba(0, 0, 0, 0.24)',
  'rgba(0, 0, 0, 0.38)',
  'rgba(0, 0, 0, 0.48)',
  'rgba(0, 0, 0, 0.6)',
  'rgba(0, 0, 0, 0.76)',
  'rgba(0, 0, 0, 0.87)',
  '#000000',
].forEach((item, index) => {
  theme.palette[`gray_opacity_${index === 0 ? '50' : index * 100}`] = item;
});

// opacity white
[
  '#000000',
  'rgba(255, 255, 255, 0.06)',
  'rgba(255, 255, 255, 0.1)',
  'rgba(255, 255, 255, 0.24)',
  'rgba(255, 255, 255, 0.38)',
  'rgba(255, 255, 255, 0.48)',
  'rgba(255, 255, 255, 0.6)',
  'rgba(255, 255, 255, 0.76)',
  'rgba(255, 255, 255, 0.87)',
  '#FFFFFF',
].forEach((item, index) => {
  theme.palette[`white_opacity_${index === 0 ? '50' : index * 100}`] = item;
});

Object.keys(theme.fontStyle).forEach((key) => {
  theme.fontStyle[`${key}_bold`] = `${theme.fontStyle[key]}
                                    font-weight: bold;
                                    `;
});

export default theme;
